import type { CSSProperties } from 'react';
import styles from './BrandDot.module.css';

interface BrandDotProps {
  style?: CSSProperties;
}

/**
 * Small pulsing orange pip with two ripple rings. Lives next to the ECHO
 * logo in AppHeader so it renders on every route. Visual ported from the
 * hero source HTML (`#ff5310`, 6px dot, 2.4s pulse, two staggered ripples).
 */
export function BrandDot({ style }: BrandDotProps = {}) {
  return (
    <span className={styles.wrap} style={style} aria-hidden>
      <span className={styles.dot} />
      <span className={styles.ripple} />
      <span className={`${styles.ripple} ${styles.ripple2}`} />
    </span>
  );
}
